import { render, staticRenderFns } from "./SiteSwitcher.vue?vue&type=template&id=379307a7&scoped=true"
import script from "./SiteSwitcher.vue?vue&type=script&lang=js"
export * from "./SiteSwitcher.vue?vue&type=script&lang=js"
import style0 from "./SiteSwitcher.vue?vue&type=style&index=0&id=379307a7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379307a7",
  null
  
)

export default component.exports